import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { LoomPricingPage as LoomPricingPageTemplate } from "@/templates/software/loom/pricing/loom-pricing-page.template.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface LoomPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<typeof pricingPageRelayQuery>;
}

export const LoomPricingPage = (props: LoomPricingPageProps) => {
    const { pricingContent, pricing, countryCode, queryRef } = props;

    return (
        <PricingContentContextProviderRelay
            productId="loom"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <LoomPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
